import { Box, Circle } from "@chakra-ui/react";
import { ReactComponent as Logo } from "../../svg/Logo.svg";
import { ReactComponent as FullLogo } from "../../svg/FullLogo.svg";
import { ReactComponent as Dashboard } from "../../svg/tachometer-alt.svg";
import { ReactComponent as Courses } from "../../svg/book.svg";
import { ReactComponent as LiveCourses } from "../../svg/live-sessions.svg";
import { ReactComponent as Announcements } from "../../svg/bullhorn.svg";
import { ReactComponent as Reports } from "../../svg/chart-line.svg";
import { ReactComponent as Settings } from "../../svg/cog.svg";
import { ReactComponent as Management } from "../../svg/management.svg";
import { ReactComponent as Schedule } from "../../svg/schedule.svg";
import { ReactComponent as Calendar } from "../../svg/calendar-view.svg";
import { ReactComponent as OpenSliderIcon } from "../../svg/chevron-right.svg";
import { ReactComponent as CloseSliderIcon } from "../../svg/chevron-left.svg";
import { useDispatch, useSelector } from "react-redux";
import {
  closeSlider,
  openSlider,
  selectedMenu,
  setAutocompleteVisibility,
} from "../../redux/actions/actions";
import MenuItemComponent from "./MenuItemComponent";
import { useLocation } from "react-router-dom";

const MenuIcons = [
  {
    component: Dashboard,
    name: "Dashboard",
    link: "/dashboard",
    bgColor: "#FD337B",
  },
  { component: Courses, name: "Library", link: "/courses", bgColor: "#fd5f3a" },
  {
    component: LiveCourses,
    name: "Live Classes",
    link: "/live-courses",
    bgColor: "#FF7251",
  },
  
  {
    component: Announcements,
    name: "Announcements",
    link: "/announcements",
    bgColor: "#FE5858",
  },
  {
    component: Calendar,
    name: "Calendar",
    link: "/calendar",
    bgColor: "#a0a4a0",
  },
  {
    component: Schedule,
    name: "Schedule",
    link: "/schedule",
    bgColor: "#a9de38",
  },
  {
    component: Management,
    name: "Manage Classes",
    link: "/manage-classes",
    bgColor: "#3E59DE",
  },
  
  
  {
    component: Reports,
    name: "Analytics",
    link: "/reports",
    bgColor: "#CEBC1F",
  },
  {
    component: Settings,
    name: "Settings",
    link: "/settings",
    bgColor: "#A0A4D9",
  },
];

export default function Sidebar() {
  const dispatch = useDispatch();
  const location = useLocation();
  const slider = useSelector((state) => state.sliderState.sliderOpen);
  // const selectedItem = useSelector((state) => state.sliderState.menuItem);

 
  const sliderHandler = () => {
    if (slider) {
      dispatch(closeSlider());
    } else {
      dispatch(openSlider());
    }
  };

  const clickHandler = (id) => {
    dispatch(selectedMenu(id));
  };

  return (
    <Box
      width={slider ? "auto" : "7.5vw"}
      d={["none", "none", "none", "flex"]}
      flexDirection="column"
      justifyContent="flex-start"
      alignItems="center"
      bgColor="white"
      py="2rem"
      boxShadow="md"
      position="fixed"
      h="100vh"
      zIndex="10"
      transition="width 500ms ease"
      onClick={(e) => {
        e.stopPropagation();
        dispatch(setAutocompleteVisibility(false));
      }}
    >
      <Box
        d="flex"
        mb="4rem"
        width="100%"
        alignItems="center"
        justifyContent={slider ? "flex-start" : "center"}
        pl={slider ? "0.75rem" : "0"}
      >
        {slider ? (
          <FullLogo width="215px" height="90px" />
        ) : (
          <Logo width="90px" height="90px" />
        )}
      </Box>

      <Box
        d={["none", "none", "none", "flex"]}
        marginX={slider ? "1.5rem" : "0"}
        flexDirection="column"
        justifyContent="space-around"
        alignItems="center"
        height="60vh"
        width="100%"
      >
        {MenuIcons.map((item, idx) => (
         
          <MenuItemComponent
            menuText={item.name}
            Component={item.component}
            key={idx}
            selected={item.link === ("/" + location.pathname.split("/")[1])}
            link={item.link}
            clickHandler={clickHandler}
            index={idx}
            bgColor={item.bgColor}
            slider={slider}
          />
        ))}
      </Box>

      <Circle
        size="35px"
        bg="#3E59DE"
        position="absolute"
        bottom="5%"
        right="-17.5px"
        boxShadow="md"
        onClick={sliderHandler}
        cursor="pointer"
      >
        {slider ? (
          <CloseSliderIcon width="8px" height="16px" fill="#ffffff" />
        ) : (
          <OpenSliderIcon width="8px" fill="#ffffff" height="16px" />
        )}
      </Circle>
    </Box>
  );
}
